import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { sesion } from "../lib/api";

// Estado de la sesión, compartido por toda la aplicación.
const AuthContexto = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Al abrir la aplicación se le pregunta al servidor si la cookie de
  // sesión sigue siendo válida.
  useEffect(() => {
    let vigente = true;
    sesion
      .estado()
      .then((datos) => {
        if (vigente && datos.isLoggedIn) setUser(datos.user);
      })
      .catch((error) => {
        console.error("No se pudo verificar la sesión", error);
      })
      .finally(() => {
        if (vigente) setCargando(false);
      });
    return () => {
      vigente = false;
    };
  }, []);

  const login = useCallback(async (username, password) => {
    const datos = await sesion.entrar(username, password);
    setUser(datos);
    return datos;
  }, []);

  const logout = useCallback(async () => {
    try {
      await sesion.salir();
    } finally {
      setUser(null);
    }
  }, []);

  return (
    <AuthContexto.Provider value={{ user, cargando, login, logout }}>
      {children}
    </AuthContexto.Provider>
  );
};

export const useAuth = () => {
  const contexto = useContext(AuthContexto);
  if (!contexto) {
    throw new Error("useAuth debe usarse dentro de un AuthProvider.");
  }
  return contexto;
};
